// extracted by mini-css-extract-plugin
export default {"key-facts":"DsSQt","keyFacts":"DsSQt","skeleton-placeholder-pulse":"Oox8X","skeletonPlaceholderPulse":"Oox8X"};